import React, { PureComponent } from 'react';
import { withStyles } from '@quillbot/design-system';
import { TextField, Theme } from '@quillbot/design-system';
import { GenericObject } from 'core/models/platform';

const styles = (theme: Theme) => ({
  root: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    overflow: 'hidden',
    borderRadius: 4,
    // backgroundColor: '#fcfcfb',
    backgroundColor: theme.palette.grey[50],
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
    '&$focused': {
      // backgroundColor: '#fff',
      boxShadow: 'none',
      backgroundColor: theme.palette.grey[50],
      borderColor: theme.palette.primary.main,
    },
  },
  mainRoot: {
    '& .MuiInputLabel-filled.MuiInputLabel-marginDense': {
      transform: 'translate(12px, 15px) scale(1)',
    },
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      transform: 'translate(12px, 7px) scale(0.75)',
    },
  },
  textFieldLabel: {
    color: theme.palette.text.disabled,
  },
  error: {
    border: `1px solid ${theme.palette.error.contrastText}`,
  },
  focused: {},
  inputMarginDense: {
    padding: '21px 12px 5px',
  },
});

class SolidBorder extends PureComponent<GenericObject> {
  render() {
    const { classes, sensitive, ...childProps } = this.props;
    return (
      <TextField
        className={sensitive && 'inspectletIgnore'}
        InputProps={{
          classes: {
            root: classes.root,
            ...classes,
          },
          disableUnderline: true,
        }}
        InputLabelProps={{
          className: classes.textFieldLabel,
        }}
        {...childProps}
        classes={{
          root: classes.mainRoot,
        }}
      />
    );
  }
}
export default withStyles(styles)(SolidBorder);
